import { render, staticRenderFns } from "./officer-form.vue?vue&type=template&id=deafb65a&scoped=true&"
import script from "./officer-form.vue?vue&type=script&lang=js&"
export * from "./officer-form.vue?vue&type=script&lang=js&"
import style0 from "./officer-form.vue?vue&type=style&index=0&id=deafb65a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deafb65a",
  null
  
)

export default component.exports